module.exports = __webpack_public_path__ + "static/videoHeader2026-15575308cd8bcdbd98c8f8eb9ddf560d.mp4";